/** @format */

import axiosInstance from "../../../services/axiosInstance";
import { STATUSES } from "./apiStatus";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getDocumentsDetailsApi = createAsyncThunk(
  "getDocumentsDetail/fetch", 
  async (token, { rejectWithValue, serializeError }) => {
    // alert("getDocumentsDetailsApi")
    try {
      // alert("getDocumentsDetailsApi");
      const response = await axiosInstance.get(`/editor/get_document_details/`,
        {
          headers: {
            "Content-type": "multipart/formData",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
     alert("error",error) 
      return rejectWithValue(serializeError(error));
    }
  },
  {
    serializeError: (err) => err.message,
  }
);

const getDocumentsDetailSlice = createSlice({
  name: "getDocumentsDetail",
  initialState: {
    documentData: {},
    documentStatus: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDocumentsDetailsApi.pending, (state, action) => {
        state.documentStatus = STATUSES.LOADING;
      })
      .addCase(getDocumentsDetailsApi.fulfilled, (state, action) => {
        state.documentData = action.payload;
        state.documentStatus = STATUSES.IDLE;
      })
      .addCase(getDocumentsDetailsApi.rejected, (state, action) => {
        state.documentStatus = STATUSES.ERROR;
      });
  },
});

export default getDocumentsDetailSlice.reducer;
